module.exports = __webpack_public_path__ + "static/media/areas.531989e8.jpg";